import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'join',
  standalone: true
})
export class JoinPipe implements PipeTransform {

  transform(items: string[], delimiter: string = ', ', lastDelimiter?: string): string {
    
    const cleanedItems = items.filter(item => !!item);

    if(cleanedItems.length <= 1){
        return cleanedItems.join('');
    }

    if(lastDelimiter){
        return [cleanedItems.slice(0, -1).join(delimiter), cleanedItems.slice(-1)].join(lastDelimiter);
    } else {
        return cleanedItems.join(delimiter);
    }

  }

}
